export const mutations = {
  addPrix(state, prix) {
    state.prix = prix
  },
  setPrix(state, prix) {
    state.prix = prix
  },
  addPrixs(state, prix) {
    state.prixs = [...prix]
  },
  addPrixsPage(state, prix) {
    state.prixs = prix
  }
}
